import React from 'react';
import { useCallbacks } from './Back.hooks';
import { BackView } from './Back.view';

export const Back = () => {
  const { handleClick } = useCallbacks();

  return <BackView onClick={handleClick} />;
};
